import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import {
  BUTTON_THEME_GREY_ADOBE,
  BUTTON_THEME_YELLOW_GREYCLIFF,
} from 'client/components/ButtonDeprecated';

const SrUtilitySetupUtilityNotNeededModal = ({ onHideUtility, onClose }) => {
  return (
    <SrSimpleMessageModal
      onClose={onClose}
      contentContainerClassName="utilityProviderNotNeeded"
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      maxWidth="375"
      iconUrl="/images/emoji-warning.png"
      iconBgColor="#FFFBEB"
      headline="Hide this utility?"
      underline
      message={
        <SrBox>
          <SrText font="greycliff" fontSize="16px" lineHeight="25px" fontWeight="600">
            Always check your lease. This tool maps available utilities to the address, however if
            your property manager does not require you to set up this utility, you can hide this
            utility. Your property manager will see this change.
          </SrText>
        </SrBox>
      }
      multiButtons={[
        {
          buttonText: 'Hide this utility',
          onButtonClick: onHideUtility,
          buttonTheme: BUTTON_THEME_YELLOW_GREYCLIFF,
        },
        {
          buttonText: 'Cancel',
          onButtonClick: onClose,
          buttonTheme: BUTTON_THEME_GREY_ADOBE,
        },
      ]}
    />
  );
};

SrUtilitySetupUtilityNotNeededModal.propTypes = {
  onHideUtility: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrUtilitySetupUtilityNotNeededModal.displayName = 'SrUtilitySetupUtilityNotNeededModal';

export default SrUtilitySetupUtilityNotNeededModal;
